import * as React from 'react';
import { cn } from '@/lib/utils';

const ModalComments = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-modal-comments', 'flex-grow', 'flex', 'flex-col', 'gap-5', className)}
    {...props}
  >
    {children}
  </div>
));
ModalComments.displayName = 'ModalComments';

const ModalCommentsHeader = React.forwardRef(({ className, children, ...props }, ref) => (
  <header
    ref={ref}
    className={cn('c-modal-comments-header', 'flex items-center justify-between', 'gap-5', 'pb-2', 'border-b', 'border-solid', 'border-neutral-lightest', className)}
    {...props}
  >
    {children}
  </header>
));
ModalCommentsHeader.displayName = 'ModalCommentsHeader';

const ModalCommentsTitle = React.forwardRef(({ className, children, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-modal-comments-title', 'text-primary-dark', 'text-base', 'mb-0 font-bold', className)}
    {...props}
  >
    {children}
  </h3>
));
ModalCommentsTitle.displayName = 'ModalCommentsTitle';

const ModalCommentsCount = React.forwardRef(({ className, children, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-modal-comments-count',
      'flex items-center',
      'gap-1',
      'text-sm',
      'font-bold',
      'text-neutral-dark',
      // Estilos aninhados para o SVG filho:
      '[&_svg]:text-neutral',
      '[&_svg]:w-5',
      'transition-colors',
      className
    )}
    {...props}
  >
    {children}
  </span>
));
ModalCommentsCount.displayName = 'ModalCommentsCount';

const ModalCommentsBody = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-modal-comments-body', 'h-[220px]', 'overflow-y-auto', 'flex-grow', 'flex', 'flex-col', className)}
    {...props}
  >
    {children}
  </div>
));
ModalCommentsBody.displayName = 'ModalCommentsBody';

const ModalCommentsPinned = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-modal-comments-pinned', 'border-b', 'border-solid', 'border-neutral-lightest', 'mb-5', 'pb-5', className)}
    {...props}
  >
    {children}
  </div>
));
ModalCommentsPinned.displayName = 'ModalCommentsPinned';

const ModalCommentsFooter = React.forwardRef(({ className, children, ...props }, ref) => (
  <footer
    ref={ref}
    className={cn('c-modal-comments-footer', className)}
    {...props}
  >
    {children}
  </footer>
));
ModalCommentsFooter.displayName = 'ModalCommentsFooter';

export { ModalComments, ModalCommentsHeader, ModalCommentsTitle, ModalCommentsCount, ModalCommentsBody, ModalCommentsPinned, ModalCommentsFooter };
